import api from '@/services/api';

let cached;
let cachedCatalog;

export const fetchPlans = async (options = {}) => {
  if (cached) {
    return cached;
  }

  const { data } = await api.get('/billing/billing/v2/price-plans-sale', {
    params: options,
  });

  const { data: liteData } = await api.get(
    '/billing/billing/v2/core-plans/lite',
    {
      params: options,
    }
  );

  const combined = [...data, ...liteData];
  cached = combined;

  return combined;
};

/**
 * The full core-plan catalog, straight from Stripe via billing-service.
 *
 * Distinct from `fetchPlans`, which hits `price-plans-sale`. That endpoint gates
 * on `isSelfServicePlan` (dedicated / elite / lite), so it omits every Hexagon
 * product key — BUSINESS, ADVISOR, GUIDANCE, PREMIUM_PEOPLE, and the SuperVision
 * ladder. `/price-plans` applies no such gate, which is why the B-side reads
 * from here.
 *
 * Public, unauthenticated, same as the sale endpoint the build already calls.
 */
export const fetchCorePlanCatalog = async (options = {}) => {
  if (cachedCatalog) {
    return cachedCatalog;
  }

  const { data } = await api.get('/billing/billing/v2/price-plans', {
    params: options,
  });

  cachedCatalog = data;

  return cachedCatalog;
};

/**
 * The plans a Recurly conversion can bill right now (`billing=recurly`, BIO-1864). The homepage,
 * the plan screens and the payment step all read this list, so a quoted price is always one
 * convert will charge. `productKeys` narrows it; empty means every sellable plan.
 */
const cachedRecurly: Record<string, Promise<any>> = {};
export const fetchRecurlySellable = (productKeys: string[] = []) => {
  const key = productKeys.join(',');
  if (!cachedRecurly[key]) {
    cachedRecurly[key] = api
      .get('/billing/billing/v2/price-plans', {
        params: { billing: 'recurly', ...(key && { productKeys: key }) },
      })
      .then(({ data }) => data)
      .catch((e) => {
        delete cachedRecurly[key];
        throw e;
      });
  }

  return cachedRecurly[key];
};

export default {
  fetchCorePlanCatalog,
  fetchPlans,
  fetchRecurlySellable,
};
